<form [formGroup]="searchBankFormGroup">
    <div class="d-lg-flex d-sm-flex mb-5">
        <div class="col-lg-6 col-sm-6 col-xs-12 p-0 mr-lg-3 mr-sm-3 field-cont">
            <label class="field-label">Bank's IFSC</label>
            <input matInput type="text" class="form-control" formControlName="ifscCode" placeholder="Eg : SBIM234567" style="text-transform: uppercase;" autocomplete="off" name="ifsc"
                   title="Please provide a valid IFSC code" (ngModelChange)="clearFieldsForIfsc()" (focusout)="searchBankByIfsc($event)" [(ngModel)]="bankAccount.ifsc">
            <mat-error class="small" *ngIf="searchBankFormGroup.controls.ifscCode.dirty && searchBankFormGroup.controls.ifscCode.errors">
                {{ getErrorMessage(searchBankFormGroup.controls.ifscCode) }}
            </mat-error>
        </div>
        <div class="col-lg-6 col-sm-6 col-xs-12 p-0 field-cont">
            <label class="field-label">Bank Name</label>
            <input matInput type="text" class="form-control" formControlName="bankName" readonly="true" [(ngModel)]="bankAccount.bank_name">
            <mat-error  class="small" *ngIf="searchBankFormGroup.controls.bankName.dirty && searchBankFormGroup.controls.bankName.errors">
                {{ getErrorMessage(searchBankFormGroup.controls.bankName) }}
            </mat-error>
        </div>
    </div>
    <div class="d-lg-flex d-sm-flex mb-5">
        <div class="col-lg-6 col-sm-6 col-xs-12 p-0 mr-lg-3 mr-sm-3 field-cont">
            <label class="field-label">Bank City</label>
            <input matInput type="text" class="form-control" formControlName="bankCity" readonly="true" [(ngModel)]="bankAccount.branch_city">
            <mat-error  class="small" *ngIf="searchBankFormGroup.controls.bankCity.dirty && searchBankFormGroup.controls.bankCity.errors">
                {{ getErrorMessage(searchBankFormGroup.controls.bankCity) }}
            </mat-error>
        </div>
        <div class="col-lg-6 col-sm-6 col-xs-12 p-0 field-cont">
            <label class="field-label">Bank Branch</label>
            <input matInput type="text" class="form-control" formControlName="bankBranchName" readonly="true" [(ngModel)]="bankAccount.branch_name">
            <mat-error  class="small" *ngIf="searchBankFormGroup.controls.bankBranchName.dirty && searchBankFormGroup.controls.bankBranchName.errors">
                {{ getErrorMessage(searchBankFormGroup.controls.bankBranchName) }}
            </mat-error>
        </div>
    </div>
</form>
